const defaultSlideState = {
  slide: {},
  slideV2: {},
  slideV2Timestamp: {},
  slideOptions: [],
  quizStatus: 1,
  countdownTimeToAnswer: 0,
  isAnswerSubmitted: false,
  isSlideAnswerSubmitting: {},
  startCountdownPickAnswer: [0],
  isLoadNextSlide: {},
  slideIndex: -1,
  maxLookbackSlideIndex: -1,
}

export default defaultSlideState
